/**
 * Format a Czech birth number (Rodné číslo) for display.
 * Input: normalized format without slash (e.g., "9001011234")
 * Output: formatted with slash (e.g., "900101/1234")
 */
export function formatBirthNumber(
	value: string | null | undefined,
): string | null {
	if (!value) return null;
	if (value.includes("/")) return value;
	if (value.length < 7) return value;
	return `${value.slice(0, 6)}/${value.slice(6)}`;
}
